<template>
  <section class="topics-section">
    <div class="topics-section__container">
      <h3 class="topics-section__heading">
        Plataforma educacional completa!
      </h3>

      <div class="topics-section__items">
        <div class="topics-section__topic">
          <CharacterIcon1Svg />
          <h5>De especialistas, para seu pequeno</h5>
          <p>Conteúdos selecionados de acordo com cada fase do desenvolvimento infantil.</p>
        </div>

        <div class="topics-section__topic">
          <CharacterIcon2Svg />
          <h5>Entretenimento que educa</h5>
          <p>Os personagens favoritos do seu pequeno e nossas produções originais têm muito a ensinar!</p>
        </div>

        <div class="topics-section__topic">
          <CharacterIcon3Svg />
          <h5>Diversão com segurança</h5>
          <p>Crianças adoram telas. Garanta um ambiente seguro para seu pequeno se divertir e fique tranquilo!</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TopicsSection'
}
</script>

<style lang="scss" scoped>
.topics-section {
  padding: 130px 20px 40px;
  background: {
    image: url('~@/assets/images/divider.svg');
    position: 50% 0;
    repeat: no-repeat;
    size: 110% auto;
  }

  &__container {
    max-width: map-get($breakpoint, 'large');
    margin: 0 auto;
  }

  &__heading {
    color: nth($color-custom, 2);
    font: {
      weight: 900;
      size: 2.1rem;
    }
    text-align: center;
  }

  &__items {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 40px;
  }

  &__topic {
    display: flex;
    flex-basis: 200px;
    flex-direction: column;
    align-items: center;
    text-align: center;

    h5 {
      margin-top: 20px;
      font: {
        weight: 700;
        size: 1.4rem;
      }
      line-height: 110%;
    }

    p {
      margin: 1em 0;
      line-height: 120%;
    }
  }

  // Responsiveness
  @include media(map-get($breakpoint, 'medium')) {
    padding: 60px 30px 30px;

    &__heading {
      font-size: 1.7rem;
    }

    &__items {
      flex-direction: column;
    }

    &__topic {
      svg {
        width: 160px;
      }

      &:nth-child(n + 2) {
        margin-top: 30px;
      }

      h5 {
        font-size: 1.3rem;
      }

      p {
        font-size: 0.95rem;
      }
    }
  }
}
</style>
